import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/menu';

export default function Testimonials() {
  const { t } = useTranslation();
  return (
    <section id="reviews" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center justify-center gap-2 text-xs font-semibold tracking-[0.3em] uppercase text-primary-600">
            <span className="h-px w-8 bg-primary-500"></span>
            {t('reviews.eyebrow')}
            <span className="h-px w-8 bg-primary-500"></span>
          </span>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight text-foreground-950 md:text-4xl">
            {t('reviews.title')}
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((item) => {
            const text = t(`reviews.t.${item.id}text`);
            return (
              <figure key={item.id} className="flex flex-col rounded-lg bg-background-50 p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  &ldquo;{text}&rdquo;
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                    <i className="ri-user-smile-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{item.name}</p>
                    <p className="text-xs text-foreground-600">{item.role}</p>
                  </div>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}